// extracted by mini-css-extract-plugin
export var formContainer = "_ko-0";
export var message = "_ko-1";